import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';

export interface StepType {
  label: string;
  fields: FormlyFieldConfig[];
}

@Component({
  selector: 'app-negative',
  templateUrl: './negative.component.html',
  styleUrls: ['./negative.component.scss'],
})
export class NegativeComponent implements OnInit {
  router: string;
  constructor(private _router: Router, private fs: AngularFirestore, private cd: ChangeDetectorRef) {
    this.router = _router.url;
   }

  ngOnInit() {
    this.cd.detectChanges();
  }

  activedStep = 0;

  model = {};
  steps: StepType[] = [
    {
      label: 'Cause',
      fields: [
        {
          key: 'reason',
          type: 'radio',
          templateOptions: {
            label: 'What went wrong?',
            required: true,
            options: [
              { value: 'waitTime', label: 'I waited for too long'},
              { value: 'overcrowded', label: 'The vehicle was overcrowded'},
              { value: 'rudeDriver', label: 'The driver was rude'},
              { value: 'recklessDriver', label: 'The driver was reckless'},
              { value: 'dirtyVehicle', label: 'The vehicle needed cleaning'},
              { value: 'accident', label: 'There was an accident'},
              { value: 'other', label: 'Something else'}
            ]
          },
        },
      ],
    },
    {
      label: 'Information',
      fields: [
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            type: 'email',
            label: 'Email ',
            placeholder: 'user@email.com',
            required: true,
          }
        },
        {
          key: 'name',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Name ',
            placeholder: 'John Doe',
          }
        },
        {
          key: 'phone',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Phone ',
            placeholder: '123-456-7890',
          }
        },
        {
          key: 'additional',
          type: 'input',
          templateOptions: {
            type: 'text',
            label: 'Additional information',
            placeholder: 'What happened?',
          }
        }
      ],
    }
  ];

  payload = {
    category: 'negative'
  };

  form = new FormArray(this.steps.map(() => new FormGroup({})));
  options = this.steps.map(() => <FormlyFormOptions> {});

  prevStep(step) {
    this.activedStep = step - 1;
  }

  nextStep(step) {
    this.activedStep = step + 1;
  }

  submit() {
    const currTime = new Date();
    this.payload['time'] = currTime.toISOString();
    this.payload['reason'] = this.model['reason'];
    this.payload['email'] = this.model['email'];
    if(this.model['additional']) {
      this.payload['details'] = this.model['additional'];
    }
    if(this.model['name']) {
      this.payload['name'] = this.model['name'];
    }
    if(this.model['phone']) {
      this.payload['phone'] = this.model['phone'];
    }
    this.fs.collection('feedback').add(this.payload);
    this._router.navigateByUrl('/feedback/confirmation', { state: ["Thank you for the feedback."]});
    this.router = '/feedback/confirmation'
  }
}
